import * as React from 'react';
import { urlEncode } from './common';
import { useForm } from 'react-hook-form';

const NewsLetterForm = () => {
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async data => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: urlEncode({
        'form-name': 'news-letter',
        ...data
      })
    }).then(() => {
      alert('Du har blivit tillagd!');
      reset();
    });
  };

  return <form method='post'
               data-netlify-honepot='bot-field'
               data-netlify='true'
               name='news-letter'
               action='/'
               className='flex rounded-lg overflow-hidden items-center input-border bg-white'
               onSubmit={handleSubmit(onSubmit)}>
    <div hidden>
      <label>
        Fyll inte i detta: <input name='bot-field' />
      </label>
    </div>
    <input name='email' placeholder='E-post' className='p-2 outline-none focus:outline-none flex-grow' type='email'
           {...register('email', { required: true })} />
    <button
      className='hover:text-primary transition-colors duration-150 px-2 bg-white h-full py-2'
      type='submit'>Registrera
    </button>
  </form>;
};

export default NewsLetterForm;